import genericAssetsPositions from '../scenes/portfolio/genericAssets/genericAssets-positions';
import genericAssetsTransactions from '../scenes/portfolio/genericAssets/genericAssets-transactions';
import ProgressIconPage from '../scenes/progressicon';
import IdConnect from '../scenes/idconnect/idconnect';
import Intermediate from '../scenes/idconnect/intermediate';
import reportAdhocStatement from '../screens/reports/report-adhoc-statement/report-adhoc-statement/report-adhoc-statement';
import reportAdhocSuccess from '../screens/reports/report-adhoc-statement/report-adhoc-success';
// import paymentStatusScreen from '../../../../src/screens/payments/payment-status-screen';
import paymentStatusModalNew from '../../../../src/screens/payments/payment-status-screen';

export default {
	'/portfolios/genericAssets': {
		component: genericAssetsPositions,
		assetCategory: 'genericAssets',
	},
	'/portfolios/genericAssets/:id': {
		component: genericAssetsTransactions,
	},
	'/progressicon': {
		component: ProgressIconPage,
	},
	'/idconnect': {
		component: IdConnect,
	},
	'/intermediate': { 
		component: Intermediate,
	},
	'/reports/adhoc-statement':{
		component: reportAdhocStatement
	},
	'/reports/adhoc-statement/success':{
		component: reportAdhocSuccess
	},
	'/payments/status-screen':{
		component: paymentStatusModalNew
	}
};